module.exports = __webpack_public_path__ + "img/mj-logo-brandname-sm.802f2dad.png";